import React from 'react'
import ReactEcharts from 'echarts-for-react';


export default function Horizontalbar({tooltip, grid, legend, xAxis, yAxis, name, type, barWidth, itemStyle, data, label, showBackground}) {
    const option = {
        tooltip: {
            ...tooltip,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(255,255,255,0.3)',
            borderWidth: 1,
            textStyle: {
                color: '#fff',
                fontWeight: 500,
                fontSize: 13,
            },
            extraCssText: `
                backdrop-filter: blur(8px);
                -webkit-backdrop-filter: blur(8px);
                border-radius: 6px;
                padding: 8px 12px;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            `,
        },
        legend: legend,
        grid: grid,
        xAxis: xAxis,
        yAxis: yAxis,
        series: [
            {
            name: name,
            type: type,
            barWidth: barWidth,
            boundaryGap:"10%",
            itemStyle: itemStyle,
            data: data,
            label: label,
            showBackground: showBackground,
            backgroundStyle: {
                color: '#00000033'
            }
            },
        ]
    };
    return (
        <ReactEcharts
            option={option}
            opts={{renderer:'svg'}}
            style={{ width: '100%', height: '100%' }}
        />
  )
}
